/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackStartExport } from "../../funcs/llmFeedbackStartExport.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmFeedbackStartExport: ToolDefinition = {
  name: "llm-feedback-start-export",
  description: `Start feedback export

Starts a background job to export all feedback data across every tenant to parquet files in S3/R2. Only one export can run simultaneously. Restricted to cluster administrators.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmFeedbackStartExport(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
